import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import ViewerDocument from '../../shared/components/ViewerDocument/ViewerDocument'

import useQuotationClient from '../../clients/QuotationClient/useQuotationClient'

const QuoteReceiptViewerMulticalculo = () => {
  const quotationClient = useQuotationClient()

  const { quotationIdentifier } = useParams()

  const [documentData, setDocumentData] = useState('')

  useEffect(() => {
    quotationClient().getQuoteReceiptViewerMulticalculo(quotationIdentifier)
      .then((response) => {
        setDocumentData(response.data)
      })
  }, [quotationIdentifier, quotationClient])

  return (
    <ViewerDocument documentBase64={documentData} />
  )
}

export default QuoteReceiptViewerMulticalculo
